import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import GenericListTab from "./../../factories/generic-list-tab";
class ShiftbookTabAssignment extends GenericListSearchTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
        this.Models.subscribe(() => {
            this.SearchConfig.CustomFilter = {
                SessionTabId: this.SessionTabId,
                ExceptShiftbookTabIds: JSON.stringify(this.Models().map((model: any) => model.ShiftbookTabId))
            };
            this.Selection([]);
        });
    }
    SaveAllowed: KnockoutObservable<boolean>;
    SearchType() {
        return "ShiftbookTab";
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }
    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            var key = ko.unwrap(button.ActionKey);
            if (key === "ShiftbookTabAssignmentMoveUp" || key === "ShiftbookTabAssignmentMoveDown") {
                button.Enabled(this.Selection() != null && this.Selection().length == 1);
            }
        });
    }
    CustomToolbarClick = (action: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(action.ActionKey);
        if (key === "ShiftbookTabAssignmentMoveUp") {
            this.moveShiftbookTab("MoveUp");
        }
        else if (key === "ShiftbookTabAssignmentMoveDown") {
            this.moveShiftbookTab("MoveDown");
        }
    };
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
    private moveShiftbookTab = (action: string) => {
        this.TabPage.IsLoading(true);
        Bao.post("ShiftbookTabAssignment/" + action + "ShiftbookTab", JSON.stringify({
            sessionTabId: this.SessionTabId,
            id: this.Selection()[0].ShiftbookTabAssignmentId
        })).done(result => {
            this.Get();
        });
    };
}
export default ShiftbookTabAssignment;